import React, { useState } from 'react';

const Summary = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="bg-yellow-100 border-l-4 border-pcc-black text-yellow-700 p-4 mb-4 max-w-screen-lg mx-auto rounded-md shadow-sm">
            <h3 className="font-bold text-lg mb-1 text-pcc-black">IMPORTANT INFORMATION</h3>
            <p className="text-sm mb-2 text-pcc-black">
                <strong>For anyone taking ENGL, POLS, PSYC, SPCH (COMM), or STAT courses:</strong><br></br>
                Starting in Fall 2025, some course numbers and titles will change to align with the new <a href="https://pasadena.edu/academics/common-course-numbering/index.php" className="underline text-blue-800 hover:text-blue-600" target="_blank" rel="noopener noreferrer">Common Course Number (CCN) system</a>.
            </p>

            <p className="text-sm mb-2 text-pcc-black">
                Find out if your course is affected —{' '}
                <button
                    onClick={() => setExpanded(!expanded)}
                    className="text-sm underline text-pcc-black focus:outline-none"
                >
                    {expanded ? 'Hide course equivalencies ▲' : 'Show course equivalencies ▼'}
                </button>{' '}
            </p>

            {expanded && (
                <div className="mt-4 overflow-x-auto">
                    <table className="min-w-full text-sm text-left text-pcc-black border-collapse border border-pcc-black">
                        <thead>
                            <tr>
                                <th className="border border-pcc-black px-2 py-1 font-bold">PCC Subject and Number</th>
                                <th className="border border-pcc-black px-2 py-1 font-bold">PCC Title</th>
                                <th className="border border-pcc-black px-2 py-1 font-bold">CCN Subject and Number</th>
                                <th className="border border-pcc-black px-2 py-1 font-bold">CCN Course Title</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                ['ENGL 001A', 'Reading and Composition', 'ENGL C1000', 'Academic Reading and Writing'],
                                ['ENGL 001AH', 'Honors Reading and Composition', 'ENGL C1000H', 'Academic Reading and Writing-Honors'],
                                ['ENGL 001C', 'Intermediate Composition-Critical Thinking and Argument', 'ENGL C1001', 'Critical Thinking and Writing'],
                                ['ENGL 001CH', 'Honors Intermediate Composition-Critical Thinking and Argument', 'ENGL C1001H', 'Critical Thinking and Writing-Honors'],
                                ['POLS 001', 'Introduction to American Government and Politics', 'POLS C1000', 'American Government and Politics'],
                                ['PSYC 001', 'Introductory Psychology', 'PSYC C1000', 'Introduction to Psychology'],
                                ['PSYC 001H', 'Honors Introductory Psychology', 'PSYC C1000H', 'Introduction to Psychology-Honors'],
                                ['SPCH 001', 'Fundamentals of Speech', 'COMM C1000', 'Introduction to Public Speaking'],
                                ['SPCH 001H', 'Honors Fundamentals of Speech', 'COMM C1000H', 'Introduction to Public Speaking-Honors'],
                                ['STAT 050', 'Elementary Statistics', 'STAT C1000', 'Introduction to Statistics'],
                                ['STAT 050H', 'Honors Elementary Statistics', 'STAT C1000H', 'Introduction to Statistics-Honors'],
                            ].map(([pccNum, pccTitle, ccnNum, ccnTitle]) => (
                                <tr key={pccNum}>
                                    <td className="border border-pcc-black px-2 py-1">{pccNum}</td>
                                    <td className="border border-pcc-black px-2 py-1">{pccTitle}</td>
                                    <td className="border border-pcc-black px-2 py-1">{ccnNum}</td>
                                    <td className="border border-pcc-black px-2 py-1">{ccnTitle}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Summary;